// utils/request.js
const crypto = require('./crypto');
const constants = require('./constants');

const handleList = [
  // '/service-user/mobile/mobileLogin'
]
let userToken = '';
let signingKey = null;   // ArrayBuffer
let encryptionKey = null;

/**
 * 设置用户凭证（登录成功后调用）
 */
async function setToken(token) {
  userToken = token;
  signingKey = await crypto.deriveKey(token, constants.a2);
  encryptionKey = await crypto.deriveKey(token, constants.a3);
}

/**
 * 生成随机 UUID (nonce)
 */
function generateNonce() {
  const buffer = new Uint8Array(16);
  for (let i = 0; i < buffer.length; i++) {
    buffer[i] = Math.floor(Math.random() * 256);
  }
  const hex = Array.from(buffer).map(b => b.toString(16).padStart(2, '0')).join('');
  return `${hex.substr(0,8)}-${hex.substr(8,4)}-${hex.substr(12,4)}-${hex.substr(16,4)}-${hex.substr(20,12)}`;
}

/**
 * 参数排序并拼接
 */
function sortParams(params) {
  if (!params) return '';
  const keys = Object.keys(params).filter(t => params[t] !== undefined && params[t] !== null && !(typeof params[t] == 'number' && isNaN(params[t]))).sort();
  return keys
    .map(k => {
      const val = params[k];
      // 值为对象或数组时，序列化成 JSON 字符串
      const str = typeof val === 'object' ? JSON.stringify(val) : val;
      return `${k}=${str}`;
    })
    .join('&');
}

/**
 * 构建签名原文
 */
function buildSignBase(params, timestamp, nonce, xplatform) {
  const paramStr = sortParams({...params, timestamp, nonce, xplatform});
  return paramStr;
}


async function generateHeaders(options) {
  const { url, method = 'GET', data = {}, header = {} } = options;
  // if (!handleList.includes(url)) return header

  const timestamp = Date.now();
  const nonce = generateNonce();
  const platform = 11;

  // 合并参数（GET query + POST body）
  let allParams = {};
  const queryIndex = url.indexOf('?');
  if (queryIndex !== -1) {
    const search = url.substring(queryIndex + 1);
    search.split('&').forEach(pair => {
      const [key, val] = pair.split('=');
      if (key) allParams[key] = decodeURIComponent(val || '');
    });
  }
  Object.assign(allParams, data);


  // 生成签名
  let signature = '';
  if (signingKey) {
    const signBase = buildSignBase(allParams, timestamp, nonce, platform);
    signature = await crypto.hmacSha256(signingKey, signBase);
  }

  // 请求头
  const headers = {
    // 'Content-Type': 'application/json',
    ...header
  };
    headers[constants.a4] = userToken;
    headers[constants.a5] = timestamp;
    headers[constants.a6] = nonce;
    headers[constants.a7] = signature;
    headers[constants.a10] = 11
  return headers
}

// 解密请求结果
async function decrypt(res, url) {
  if (typeof res === 'object' && 'encrypted' in res) {
    const decryptedStr = await crypto.aesGcmDecrypt(res.encrypted, encryptionKey);
    const decryptedData = JSON.parse(decryptedStr);
    // console.log(url, decryptedData)
    return decryptedData
  }
  return res
}


module.exports = {
  setToken,
  generateHeaders,
  decrypt,
  getSigningKey: () => signingKey,
  getEncryptionKey: () => encryptionKey
};